import getAsyncStatusKeyPath from 'shared/utils/getAsyncStatusKeyPath';

export const baseKeyPath = ['settings'];

/**
 * Generate the Settings keypath
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 */
const keyPath = asyncId => getAsyncStatusKeyPath(asyncId, baseKeyPath);

export default keyPath;
